class NavProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.links = this.querySelectorAll('a');

    // Update the specific link to point to the correct ID
    this.updateCustomerReviewsLink();

    this.sections = Array.from(this.links)
      .map((link) => document.querySelector(link.getAttribute('href')))
      .filter((section) => section !== null);
    this.observe();
    this.links.forEach((link) => {
      link.addEventListener('click', this.onLinkClick.bind(this));
    });
  }

  updateCustomerReviewsLink() {
    this.links.forEach((link) => {
      if (link.textContent.trim() === 'Customer Reviews') {
        link.setAttribute('href', '#judgeme_product_reviews');
      }
    });
  }

  observe() {
    window.addEventListener('scroll', () => {
      const activeSection = this.sections.find((section) => isInView(section));

      if (!activeSection && window.scrollY <= this.sections[0].offsetHeight) {
        this.links.forEach((link, index) => {
          link.classList.toggle('is-active', index === 0);
        });
        return;
      }

      this.links.forEach((link) => {
        link.classList.toggle(
          'is-active',
          link.getAttribute('href').replace('#', '') === activeSection?.id,
        );
      });
    });
  }

  onLinkClick(e) {
    e.preventDefault();

    const section = document.querySelector(e.target.getAttribute('href'));

    if (!section) return;

    section.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
}

customElements.define('nav-product', NavProduct);
